import { TCustomComponent } from '@/type/ui/ui.type';
import { twMerge } from 'tailwind-merge';

type MenuItemProps = {
  titleClassName?: string;
  title: string;
  active?: boolean;
  icon?: React.ComponentType<TCustomComponent>;
  iconClassName?: string;
  children?: React.ReactNode;
};

const MenuItem = ({
  titleClassName,
  title,
  active,
  icon: Icon,
  iconClassName,
  children,
}: MenuItemProps) => {
  return (
    <div
      className={twMerge('menu-item', active && 'show active here')}
      data-menu-item-toggle="accordion"
      data-menu-item-trigger="click"
    >
      <div
        className="menu-link flex items-center grow cursor-pointer border-transparent gap-[10px] pl-[10px] pr-[10px] py-[15px]"
        tabIndex={0}
      >
        {Icon && (
          <div className="flex justify-center items-center mr-1.75">
            {
              <Icon
                className={twMerge(
                  'w-[19.5px] h-[19.5px] [&>path]:fill-gray-99A1B6 [&>path]:menu-item-active:fill-black-252E49 [&>path]:dark-mode:menu-link-hover:fill-gray-900 [&>path]:dark-mode:menu-item-active:fill-gray-900',
                  iconClassName,
                )}
              />
            }
          </div>
        )}
        <div
          className={twMerge(
            'menu-title text-[15.5px] text-black-252E49 select-none menu-item-active:text-black-252E49 menu-link-hover:text-black-252E49 dark-mode:text-gray-800 dark-mode:menu-link-hover:text-gray-900 dark-mode:menu-item-active:text-gray-900',
            titleClassName,
          )}
        >
          {title}
        </div>
        {children && (
          <div className="menu-arrow text-gray-C5C9D9 w-[20px] shrink-0 justify-end ml-1 mr-[-10px] dark-mode:text-gray-500 dark-mode:menu-item-active:text-gray-900">
            <i className="ki-outline ki-left rotate-90 text-md menu-item-show:hidden"></i>
            <i className="ki-outline ki-left -rotate-90 text-md hidden menu-item-show:inline-flex"></i>
          </div>
        )}
      </div>
      <div
        className={twMerge(
          'menu-accordion gap-0.5 pl-[10px] relative',
          active && 'show !h-auto',
        )}
      >
        {children}
      </div>
    </div>
  );
};

export default MenuItem;
